// extracted by mini-css-extract-plugin
export default {"paletteContainer":"YVUFSG98A5yb88qKKdsB","wide":"eCz6Arj90j3zNnHRYrlc","viewSwitchButton":"pU1foLmpxcQLjFW7aIKy"};